import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import LoadingSpinner from 'components/LoadingSpinner';
import logger from 'logger';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setConferenceAction } from 'store/conference/conferenceActions';
import { authorizeTokenAction } from 'store/user/userActions';
import { setConferenceStandby, listArchives, listConvertJobs } from 'utils/apiCalls';
import FilesTable from './components/FilesTable';
import FileUpload from './components/FileUpload';
import VodsTable from './components/VodsTab';
import DownloadArchive from './components/DownloadArchive';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '50rem',
    marginTop: '1rem',
    maxWidth: '95%',
    margin: '0 auto',
    backgroundColor: theme.palette.background.light,
    padding: '1rem',
  },
  infoArea: {
    width: '100%',
    padding: '1rem',
    backgroundColor: theme.palette.background.dark,
    ...theme.mixins.borderRadius(),
    ...theme.mixins.shadow(),
    '& > *': {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& > *:first-child': {
        fontWeight: 'bold',
        textDecoration: 'underline',
        fontSize: '110%',
        marginRight: '3rem',
      },
      '& > *:last-child': {},
    },
  },
  uploadWrapper: {
    marginTop: '1rem',
    width: '100%',
  },
  fileTableWrapper: {
    marginTop: '1rem',
    width: '100%',
  },
  vodWrapper: {
    marginTop: '1rem',
  },
  standbyControl: {
    width: '100%',
    marginTop: '1rem',
  },
}));

const Index = () => {
  const [changingStandby, setChangingStandby] = useState(false);
  const [tab, setTab] = useState(0);
  const [archives, setArchives] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [mp4s, setMp4s] = useState([]);
  const dispatch = useDispatch();

  const classes = useStyles();
  const {
    SessionId,
    title,
    description,
    Videos,
    Standby,
    authTokenLoading,
    authTokenError,
  } = useSelector(({ conference, user }) => ({
    SessionId: conference.SessionId,
    title: conference.Title,
    descriptionText: conference.Description,
    Videos: conference.Videos,
    Standby: conference.Standby,
    authTokenLoading: user.actionStatus?.authorizeToken?.loading,
    authTokenError: user.actionStatus?.authorizeToken?.error,
  }));

  const queryRef = new URLSearchParams(useLocation().search);
  const query = useRef(queryRef);

  useEffect(() => {
    const token = query.current.get('token');
    localStorage.setItem('conference-token', btoa(token));
    // removeTokenFromQuery();
    dispatch(authorizeTokenAction({ token }));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const getArchives = async () => {
      const resp = await listArchives(SessionId);
      const jobresp = await listConvertJobs('PROGRESSING', SessionId);
      setArchives(resp.data.archives);
      setMp4s(resp.data.mp4s);
      setJobs(jobresp.data);
    };
    if (SessionId) getArchives();
  }, [SessionId]);

  const getJobs = async () => {
    const jobresp = await listConvertJobs('PROGRESSING', SessionId);
    setJobs(jobresp.data);
  };

  if (authTokenLoading) return <LoadingSpinner />;
  if (authTokenError) return null;

  const changeStandby = async (event) => {
    setChangingStandby(true);

    try {
      const newConferenceData = await setConferenceStandby(SessionId, {
        Name: event.target.value,
        Key: `${SessionId}/mp4s/${event.target.value}`,
      });
      dispatch(setConferenceAction(newConferenceData.data));
    } catch (e) {
      logger.error('Error setting new standby', { e });
    }

    setChangingStandby(false);
  };

  return (
    <div className={classes.root}>
      <div className={classes.infoArea}>
        <div>
          <div>Streaming Session Id:</div>
          <div>{SessionId}</div>
        </div>
        <div>
          <div>Title:</div>
          <div>{title}</div>
        </div>
        <div>
          <div>Description:</div>
          <div>{description}</div>
        </div>
      </div>
      <Paper
        style={{
          flexGrow: 1,
        }}
      >
        <Tabs
          value={tab}
          onChange={(event, newTab) => setTab(newTab)}
          indicatorColor="primary"
          textColor="primary"
          centered
        >
          <Tab label="Session Media" />
          <Tab label="Video On Demand" />
          <Tab label="Download" />
        </Tabs>
      </Paper>

      {tab === 0 && (
        <>
          <div className={classes.uploadWrapper}>
            <FileUpload SessionId={SessionId} />
          </div>

          <div className={classes.fileTableWrapper}>
            <FormControl className={classes.standbyControl}>
              <InputLabel id="standby-label">Standby Video</InputLabel>
              <Select
                labelId="standby-label"
                value={Standby?.Name}
                disabled={changingStandby}
                onChange={changeStandby}
              >
                {Videos &&
                  Videos.map((video) => (
                    <MenuItem key={video.Name} value={video.Name}>
                      {video.Name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FilesTable videos={Videos} sessionId={SessionId} />
          </div>
        </>
      )}
      {tab === 1 && (
        <div className={classes.fileTableWrapper}>
          <VodsTable />
        </div>
      )}
      {tab === 2 && (
        <div className={classes.fileTableWrapper}>
          <DownloadArchive archives={archives} mp4s={mp4s} jobs={jobs} getJobs={getJobs} />
        </div>
      )}
    </div>
  );
};

export default Index;
